import { render, staticRenderFns } from "./CalcFormItemFibreLower.vue?vue&type=template&id=3b4c2500&"
import script from "./CalcFormItemFibreLower.vue?vue&type=script&lang=js&"
export * from "./CalcFormItemFibreLower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports